import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('__clipara-root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

{
  /* <script defer src="./build/static/js/main.3d7089dc.js" type="text/javascript" />
<link href="./build/static/css/main.c6c0afe8.css" rel="stylesheet" /> */
}
